import { render } from "./MetricsTable.vue?vue&type=template&id=3b283eba&scoped=true"
import script from "./MetricsTable.vue?vue&type=script&lang=js"
export * from "./MetricsTable.vue?vue&type=script&lang=js"

import "./MetricsTable.vue?vue&type=style&index=0&id=3b283eba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b283eba"]])

export default __exports__